import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import styled from 'styled-components';

import {red, white} from '@drivesally/sally-ui/lib/libs/colors';

import routeCrm from '../../pages/CrmPage/route';

const Banner = styled(Link)`
  background: ${({inverted}) => (inverted ? white : red)};
  border-radius: 4px;
  color: ${({inverted}) => (inverted ? red : white)};
  font-size: 13px;
  font-weight: 600;
  margin-right: 16px;
  padding: 8px 12px;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    opacity: 0.9;
  }

  @media (max-width: 768px) {
    font-size: 11px;
    margin-right: 8px;
    padding: 4px 8px;
  }
`;

const OpsUserCrmTicketBanner = ({count, inverted}) => {
  if (!count) return null;

  return (
    <Banner inverted={inverted} to={routeCrm()}>
      CRM ({count})
    </Banner>
  );
};

OpsUserCrmTicketBanner.propTypes = {
  count: PropTypes.number,
  inverted: PropTypes.bool,
};

export default OpsUserCrmTicketBanner;
